import * as React from "react";
const SvgArrowLong = (props) => /* @__PURE__ */ React.createElement("svg", { width: 34, height: 20, viewBox: "0 0 34 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 10H32M32 10L23.04 1M32 10L23.04 19", stroke: "black", strokeWidth: 2 }));
export default SvgArrowLong;
